// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root___gMhe","disabled":"FileBtn_disabled__1d-kU","warn":"FileBtn_warn__2WxuZ","fade":"FileBtn_fade__poOgg"};